import List from "@/components/ui/objects/List";
const sections = [
  {
    title: "¿Qué es el ENFEN?",
    slug: "que-es-enfen",
    content: () => [
      <p>
        La recurrencia del Fenómeno El Niño y sus efectos sobre las actividades
        socio-económicas de los países miembros de la{" "}
        <a href="http://www.cpps-int.org/">
          Comisión Permanente del Pacífico Sur - CPPS
        </a>
        (COLOMBIA, ECUADOR, PERU y CHILE), llevó a la creación del Programa{" "}
        <b>"Estudio Regional del Fenómeno El Niño"</b> (ERFEN), el cual fue
        configurado en 1974 e inició sus actividades en 1976.
      </p>,
      <p>
        El Programa ERFEN es un programa integral y multidisciplinario para el
        estudio del Fenómeno El Niño, en los campos meteorológico, oceanográfico
        (físico y químico), biológico-marino, biológico-pesquero, de
        capacitación y socio-económico. Inicialmente el énfasis de estudio fue
        la oceanografía biológica, posteriormente amplió a los aspectos físicos
        oceanográficos y meteorológicos y los aspectos de impactos regionales
        como los biológico-pesqueros relativos a la incidencia del fenómeno en
        los recursos hidrobiológicos pesqueros. El ERFEN funciona con la
        participación de instituciones de investigación de los países miembros,
        bajo la coordinación de la <a href="http://www.cpps-int.org/">CPPS</a> y
        con el apoyo de otras organizaciones internacionales.
      </p>,
      <p>
        En el Perú la instancia competente en el Programa ERFEN es la Comisión
        Multisectorial encargada del{" "}
        <b>Estudio Nacional del Fenómeno El Niño (ENFEN)</b>, el cual fue
        constituido el 07 de junio de 1977.
      </p>
    ]
  },
  {
    title: "¿Quiénes integran el ENFEN en la actualidad?",
    slug: "quienes-integran-ENFEN",
    content: () => [
      <List horizontal>
        <li>Autoridad Nacional del Agua (ANA)</li>
        <li>
          Dirección de Hidrografía y Navegación de la Marina de Guerra del Perú
          (DHN)
        </li>
        <li>Instituto de Defensa Civil (INDECI)</li>
        <li>Instituto del Mar del Perú (IMARPE)</li>
        <li>Instituto Geofísico del Perú (IGP)</li>
        <li>Servicio Nacional de Meteorología e Hidrología (SENAMHI)</li>
        <li>
          Centro Nacional de Estimación, Prevención y Reducción del Riesgo de
          Desastre (CENEPRED)
        </li>
      </List>
    ]
  },
  {
    title: "¿Cuáles son los objetivos del ENFEN?",
    slug: "objetivos-ENFEN",
    content: () => [
      <List>
        <li>
          Estudiar el Fenómeno "El Niño", a fin de lograr una mejor comprensión
          del mismo, poder predecirlo y determinar sus probables consecuencias.
        </li>
        <li>
          Coordinar, recomendar y asesorar las actividades vinculadas con el
          fenómeno "El Niño", en el ámbito nacional.
        </li>
        <li>
          Coordinar a nivel internacional los asuntos ligados al Proyecto
          "Estudio Regional del Fenómeno El Niño" (ERFEN).
        </li>
      </List>
    ]
  },
  {
    title: "¿Cuáles son las funciones del ENFEN?",
    slug: "funciones-ENFEN",
    content: () => [
      <List>
        <li>
          Mantener informado sobre la posible ocurrencia del Fenómeno "El Niño",
          para que con ello se permita adoptar decisiones para adecuar y
          proteger la infraestructura existente en los distintos sectores, en
          prevención a los posibles daños que pudiera causar este Fenómeno a la
          economéa nacional y la población peruana.
        </li>
        <li>
          Orientar a los diversos sectores medidas pragmáticas de previsión que
          permitan reducir daños y/o aprovechar beneficios.des vinculadas con el
          fenómeno "El Niño", en el ámbito nacional.
        </li>
        <li>
          Mantener adecuadamente informada a la población sobre las posibles
          variaciones de su desarrollo.
        </li>
        <li>
          Recomendar, asesorar y coordinar las diversas actividades vinculadas
          al estudio del Fenómeno "El Niño".
        </li>
        <li>
          Participar en certámenes nacionales e internacionales vinculados al
          estudio del Fenómeno "El Niño", con la intención de lograr la mejor
          información técnica posible y conocer los avances en los estudios de
          sus diversos aspectos: técnico-cientéfico y económico-social.
        </li>
        <li>
          "La Comisión" establecerá contacto permanente con el Secretario
          Científico de la Comisión Permanente del Pacífico Sur, CPPS,
          Coordinadora del Proyecto Regional del Fenómeno "El Niño", ERFEN, con
          miras a obtener una más amplia cobertura de datos a través de ella y
          posibilitar la participación coordinada de las instituciones
          interesadas del país, en dicho proyecto.
        </li>
      </List>
    ]
  }
];

function getSections() {
  return sections;
}

export { getSections };
